import React from 'react';

const Footer = () => (
  <footer className="nf-footer">
    <div className="nf-footer__inner">
      <div className="nf-footer__text">
        <p className="nf-footer__label">Registered address</p>
        <p className="nf-footer__address">
          22A-2A, Jalan PJU 1/3B, Block B,<br />
          Sunwaymas Commercial Centre,<br />
          47301 Petaling Jaya,<br />
          Selangor Darul Ehsan, Malaysia<br />
          <br />
          Tel: <a href="tel:60173232024" style={{ color: 'inherit' }}>+6017 323 2024</a><br />
          Email: <a href="mailto:info@nafas.design" style={{ color: 'inherit' }}>info@nafas.design</a>
        </p>
      </div>
      <div className="nf-footer__image-wrap">
        <img
          src="/assets/images/contact/contact-min.jpg"
          alt="NAF Architecture Studio"
          className="nf-footer__image"
        />
      </div>
    </div>
    <p className="nf-footer__copy">2026 NAF Architects Studio.</p>
  </footer>
);

export default Footer;
